import { forwardRef } from 'react';
import { NavLinkProps, NavLink as NavLinkRouter } from 'react-router-dom';

export const SideMenuLink = forwardRef<any, any>(function Link(itemProps, ref) {
  return (
    <NavLinkRouter
      ref={ref}
      className={({ isActive }) => `${itemProps.className ?? ''} ${isActive ? 'active' : ''}`}
      {...(itemProps as NavLinkProps)}
      role={undefined}
    />
  );
});
